import editForm from './credit-applicant-entity.form';
import { CustomComponentType, CustomBuilderGroups, LoanRoleType } from '../../../enums';
import { PrimaryRoleRepeaterWidgetVue } from '../primary-role-repeater-widget/primary-role-repeater-widget-vue';

export default class CreditApplicantEntityWidgetVue extends PrimaryRoleRepeaterWidgetVue {
	static schema(...extend: any) {
		return PrimaryRoleRepeaterWidgetVue.schema(
			{
				label: 'Credit Applicant',
				type: CustomComponentType.creditApplicantEntity,
				key: CustomComponentType.creditApplicantEntity,
				addAnother: 'Add a Credit Applicant'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Credit Applicant',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: CreditApplicantEntityWidgetVue.schema({})
		};
	}

	init() {
		this.roleType = LoanRoleType.CreditApplicant;
		super.init();
	}
}
